import axios from "axios";
import { CarrierList } from "../component/carrier/Type";
import { ServerSideTypes } from "../types/OperationCommonTypes";

const CarrierAction = () => {
  const baseUrl = ``;

  const getCarrier = async (
    tenant: string,
    data: CarrierList.SearchFunctionDataType,
    params: ServerSideTypes.IParams
  ) => {
    return await axios
      .get(`${baseUrl}/masterdatasupplier/carrier/pagination`, {
        params: {
          tenant: tenant,
          name: data?.name ? data?.name : null,
          bpCode: data?.bpCode ? data?.bpCode : null,
          ...params,
        },
      })
      .then((response) => response.data);
  };

  const getCarrierById = async (id: number, tenant: string) => {
    return await axios
      .get(`/masterdatasupplier/carrier/${id}`, {
        params: {
          tenant: tenant,
        },
      })
      .then((response) => response.data);
  };

  const updateCarrier = async (
    id: number,
    params: CarrierList.EditCarrierType,
    tenant: string
  ) => {
    return await axios.put(
      `${baseUrl}/masterdatasupplier/carrier/${id}`,
      params,
      { params: { tenant: tenant } }
    );
  };

  const exportCarrier = async (tenant: string,
    data: CarrierList.SearchFunctionDataType,) => {
    return await axios.get(`${baseUrl}/masterdatasupplier/carrier/excel`, {
      params:{tenant,...data},
      responseType: "arraybuffer",
      headers: { "Access-Control-Allow-Origin": true },
    });
  };

  return {
    getCarrier,
    updateCarrier,
    exportCarrier,
    getCarrierById,
  };
};

export default CarrierAction;
